/*
 * @Author: zjw
 * @Date: 2021-06-10 15:46:43
 * @LastEditTime: 2022-11-16 16:26:22
 * @FilePath: \web-app\src\network\content\tagClass.js
 * @Environment: Vue + Element
 * @Description: 标签管理
 */
import {
    request,
} from '../request.js'

// 标签分类列表
export function tagClassList(data) {
    return request({
        url: '/web/back/sys/tag-collection/page',
        method: 'post',
        data
    })
}

// 添加
export function addTagClass(data) {
    return request({
        url: '/web/back/sys/tag-collection/insert',
        method: 'post',
        data
    })
}



// 修改
export function editTagClass(data) {
    return request({
        url: '/web/back/sys/tag-collection/update',
        method: 'post',
        data
    })
}

// 删除
export function delTagClass(data) {
    return request({
        url: '/web/back/sys/tag-collection/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelTagClass(data) {
    return request({
        url: '/web/back/sys/tag-collection/batch/delete',
        method: 'delete',
        data
    })
}
